"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventEmitter = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
/**
 * 
 * 
useage:

interface MyEventData {
  message: string;
}

const eventEmitter = new EventEmitter<MyEventData>();

// subscribe
const handler1: EventHandler<MyEventData> = (data) => {
  console.log(`Handler 1 received: ${data.message}`);
};

eventEmitter.on('customEvent', handler1);

// emit
eventEmitter.emit('customEvent', { message: 'Hello, Event Emitter!' });

// cancel
eventEmitter.off('customEvent', handler1);
 */
class EventEmitter {
  constructor() {
    (0, _defineProperty2.default)(this, "events", new Map());
  }
  on(event, handler) {
    if (!this.events.has(event)) {
      this.events.set(event, []);
    }
    this.events.get(event).push(handler);
  }
  off(event, handler) {
    if (this.events.has(event)) {
      const handlers = this.events.get(event);
      const index = handlers.indexOf(handler);
      if (index !== -1) {
        handlers.splice(index, 1);
      }
      if (handlers.length === 0) {
        this.events.delete(event);
      }
    }
  }
  emit(event, data) {
    if (this.events.has(event)) {
      const handlers = this.events.get(event);
      handlers.forEach(handler => handler(data));
    }
  }
}
exports.EventEmitter = EventEmitter;